module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.info.pointer) ? _c('router-link', {
    staticClass: "footer-block",
    style: (_vm.info.pointer ? _vm.style : ''),
    attrs: {
      "to": _vm.info.url ? _vm.info.url : '/'
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('p', {
    staticClass: "smalltitle"
  }, [_vm._v(_vm._s(_vm.info.smalltitle))])]) : _c('div', {
    staticClass: "footer-block",
    style: (_vm.info.pointer ? _vm.style : '')
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('p', {
    staticClass: "smalltitle"
  }, [_vm._v(_vm._s(_vm.info.smalltitle))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e7ad544!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Block.vue
// module id = 170
// module chunks = 1